<template>
  <div class="content_box">
    <el-form :inline="true" size="mini">
      <el-form-item label="核销状态:" style="margin:0 20px">
        <el-select v-model="listQuery.cardStatus" placeholder="请选择" clearable>
          <div v-for="(item, index) in cardStatusList" :key="index">
            <el-option :label="item.name" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item>
      <el-form-item label="手机号: " style="margin-right:20px">
        <el-input v-model="listQuery.userPhone" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="优惠券名称: " style="margin-right:20px">
        <el-input v-model="listQuery.couponTitle" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getListData" v-waves>搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" v-waves @click="handleAdd" style="margin: 0 20px 0 0">新增</el-button>
      </el-form-item>
    </el-form>

    <ElTable
      :columns="listHeader"
      :tableData="tableData"
      :loading="loading"
      :total="listQuery.total"
      @handleCurrentChange="handleCurrentChange"
      @handleSizeChange="handleSizeChange"
    >
      <template slot="writeOffTime" slot-scope="{ row }">
        <el-tag
          v-if="row.writeOffTime"
          type="danger"
          effect="dark"
          size="mini"
        >{{ row.writeOffTime }}</el-tag>
        <div v-else>-</div>
      </template>
      <template slot="receiveUser" slot-scope="{ row }">{{ row.receiveUser ?row.receiveUser :'-' }}</template>

      <template slot="cardStatus" slot-scope="{ row }">
        <el-tag v-if="row.cardStatus === 0" effect="dark" size="mini" type="danger">未领取</el-tag>
        <el-tag v-if="row.cardStatus === 1" effect="dark" size="mini" type="danger">未核销</el-tag>
        <el-tag v-if="row.cardStatus === 2" type="success" effect="dark" size="mini">已核销</el-tag>
      </template>
      <template slot="operation" slot-scope="{ row }">
        <div class="operation">
          <el-button size="mini" type="text" @click="handleSave(row)">克隆优惠券</el-button>
          <el-button
            size="mini"
            type="text"
            style="color: rgb(255, 0, 0);"
            @click="handleEdit(row)"
            :disabled="row.cardStatus == 2"
          >编辑</el-button>
          <el-button
            size="mini"
            type="text"
            style="color: rgb(255, 0, 0);"
            @click="handleDelete(row)"
          >删除</el-button>
        </div>
      </template>
    </ElTable>

    <!-- 表单弹窗 -->
    <el-dialog :title="dialogName" :visible.sync="dialogVisible" :close-on-click-modal="false">
      <el-form ref="form" :model="dialogForm" label-width="120px">
        <el-form-item label="卡券名称" required>
          <el-input clearable v-model="dialogForm.couponTitle" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="卡券描述" required>
          <el-input clearable v-model="dialogForm.msg" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="优惠券价格" required>
          <el-input clearable v-model="dialogForm.price" placeholder="请输入" type="number"></el-input>
        </el-form-item>

        <el-form-item label="满多少可用" required>
          <el-input clearable v-model="dialogForm.maxPrice" placeholder="请输入" type="number"></el-input>
        </el-form-item>

        <el-form-item label="所属人手机号" required>
          <el-input clearable v-model="dialogForm.userPhone" placeholder="请输入" type="number"></el-input>
        </el-form-item>

        <el-form-item label="状态:" required>
          <el-select
            v-model="dialogForm.cardStatus"
            placeholder="请选择"
            style="width: 100%"
            clearable
          >
            <div v-for="(item, index) in cardStatusList" :key="index">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import filterQueryFormItems from "./filterQueryFormItems";
import StoreToString from "@/components/filters/storeToString.vue";
import {
  selectApi,
  deleteApi,
  addApi,
  updateApi
} from "@/services/mall/coupon";
import { mapState } from "vuex";
export default {
  components: {
    ElTable,
    StoreToString
  },
  async created() {
    this.getListData();
  },
  data() {
    return {
      dialogVisible: false,
      dialogName: "",
      dialogForm: {},
      //0未领取 1未使用  2已使用  3已过期 4已删除
      cardStatusList: [
        // { id: 0, name: "未领取" },
        { id: 1, name: "未核销" },
        { id: 2, name: "已核销" }
      ],
      loading: false,
      listQuery: {
        type: 1, // 1会员卡 2优惠券
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },
      /* 表格数据 */
      tableData: []
    };
  },
  computed: {
    filterQueryFormItems,
    listHeader,
    ...mapState(["userInfo"])
  },
  watch: {},
  methods: {
    async getListData() {
      let listQuery = JSON.parse(JSON.stringify(this.listQuery));
      // listQuery.store_id =
      //   listQuery.store_id?.join(",") || this.userInfo.store_id;
      this.loading = true;
      const { data, code, count } = await selectApi({
        ...listQuery
      });
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },
    /* 搜索按钮 */
    async search(listQuery) {
      this.listQuery = listQuery;
      this.getListData();
    },
    /* 分页 */
    handleCurrentChange(e) {
      console.log(e);
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      console.log(e);
      this.listQuery.pageSize = e;
      this.getListData();
    },

    /* 新增 */
    handleAdd() {
      this.dialogVisible = true;
      this.dialogName = "创建";
      this.dialogForm = {};
    },

    /* 修改 */
    handleEdit(row) {
      this.dialogVisible = true;
      this.dialogName = "编辑";
      this.dialogForm = JSON.parse(JSON.stringify(row));
    },

    /* 克隆 */
    handleSave(row) {
      let { couponTitle, msg, price, maxPrice } = row;
      addApi({
        couponTitle,
        msg,
        price,
        maxPrice,
        type: 1,
        source: 1,
        cardStatus: 1
      }).then(res => {
        if (res.code === 200) {
          this.listQuery.pageNumber = 1;
          this.getListData();
          this.$message({
            type: "success",
            message: "创建成功!"
          });
        }
      });
    },
    save() {
      if (!this.dialogForm.price) {
        this.$message.error("请填写优惠券价格");
        return;
      }
      if (!this.dialogForm.maxPrice && this.dialogForm.maxPrice !== 0) {
        this.$message.error("请填写满多少可用");
        return;
      }
      if (
        !this.dialogForm.couponTitle ||
        !this.dialogForm.msg ||
        !this.dialogForm.cardStatus ||
        !this.dialogForm.userPhone
      ) {
        this.$message.error("请填写必填字段");
        return;
      }

      if (this.dialogName === "创建") {
        addApi({
          ...this.dialogForm,
          type: 1,
          source: 1,
          cardStatus: 1
        }).then(res => {
          if (res.code === 200) {
            this.listQuery.pageNumber = 1;
            this.getListData();
            this.$message({
              type: "success",
              message: "创建成功!"
            });
            this.dialogVisible = false;
          }
        });
      }
      if (this.dialogName === "编辑") {
        let receiveUser = "";
        if (this.dialogForm.cardStatus == 2) {
          receiveUser = this.userInfo.phone_number;
        }
        updateApi({
          ...this.dialogForm,
          receiveUser
        }).then(res => {
          console.log("编辑", res);
          if (res.code === 200) {
            this.getListData();
            this.$message({
              type: "success",
              message: "编辑成功!"
            });
            this.dialogVisible = false;
          }
        });
      }
    },

    /* 删除 */
    handleDelete(row) {
      this.$confirm(`确定删除卡券"${row.couponTitle}"吗?`, "禁用", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(res => {
        deleteApi({ id: row.id }).then(res => {
          if (res.code === 200) {
            this.getListData();
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          }
        });
      });
    }
  }
};
</script>

<style scoped lang="less">
.content_box {
  width: 100%;
}
.selectForm {
  background: #fff;
  // max-width: 1405px;
  padding: 10px 0;
  margin: 10px auto;
}
.tableList {
  border-radius: 6px;
  background: #fff;
  // max-width: 1405px;
  margin: 10px auto;
}

.operation {
  a {
    margin-right: 10px;
  }
}
</style>
